import { useTranslation } from "react-i18next";

export default function CTA() {
  const { t } = useTranslation();

  return (
    <section
      id="contact"
      className="relative min-h-[70vh] md:min-h-[80vh] w-full flex items-center overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Panoramic%20ultra%20wide%20angle%20of%20a%20luxury%20music%20composition%20studio%20with%20state%20of%20the%20art%20acoustic%20design%20premium%20wooden%20acoustic%20panels%20on%20deep%20charcoal%20walls%20elegant%20grand%20piano%20reflection%20on%20polished%20marble%20floor%20warm%20ambient%20floor%20lighting%20with%20champagne%20gold%20tones%20floor%20to%20ceiling%20windows%20showing%20abstract%20blurred%20city%20night%20lights%20exclusive%20private%20club%20atmosphere%20no%20text%20cinematic%20architectural%20photography&width=1920&height=800&seq=2&orientation=landscape"
          alt="Premium studio"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-deepblack/50" />
      </div>

      <div className="relative z-10 w-full px-6 md:px-12 lg:px-16 py-20">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-6">
            <h2 className="text-marble font-serif text-xl md:text-4xl lg:text-5xl font-light tracking-wide leading-tight whitespace-nowrap">
              {t("cta.title")}
            </h2>
            <a
              href="/inquiry"
              className="inline-flex items-center gap-3 mt-8 bg-champagne hover:bg-champagne/90 text-deepblack px-8 py-3.5 rounded-full text-sm font-sans tracking-widest uppercase transition-all duration-300 group"
            >
              {t("cta.button")}
              <span className="w-6 h-6 rounded-full bg-deepblack/15 flex items-center justify-center group-hover:bg-deepblack/25 transition-colors">
                <i className="ri-arrow-right-line text-deepblack text-sm" />
              </span>
            </a>
          </div>

          <div className="lg:col-span-5 lg:col-start-8">
            <p className="text-marble/70 text-sm md:text-base font-sans leading-relaxed whitespace-pre-line">
              {t("cta.description")}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}